// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"6028c02d","52":"85618225","252":"7cbc1982","329":"9520baa2","349":"701d60cb","453":"d855a71b","456":"ff5aa5d7","522":"513de31f","794":"273e5f0c","852":"92b94dbd","876":"b3410eb5"}[chunkId] + ".chunk.js";
};